'use client';

const ProductDetailsHeader = () => {
  return (
    <section
      className="page-header bg--cover"
      style={{ backgroundImage: 'url(/images/header/1.png)' }}
    >
      <div className="container">
        <div
          className="page-header__content"
          data-aos="fade-right"
          data-aos-duration={1000}
        >
          <h1>Product Details</h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-center mb-0">
              <li className="breadcrumb-item ">
                <a href="index.html">Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Product Details
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </section>
  );
};

export default ProductDetailsHeader;
